import React from "react";
import Image from "../assets/Imgf.svg";
import { FaGithub, FaDribbble, FaLinkedin } from "react-icons/fa";
import { TypeAnimation } from "react-type-animation";
import { motion } from "framer-motion";
import { fadeIn, fadein } from "../variants";

const Banner = () => {
  return (
    <section
      className="min-h-[85vh] lg:min-h-[78vh] flex items-center"
      id="home"
    >
      <div className="container mx-auto">
        <div className="flex flex-col gap-y-8 lg:flex-row lg:items-center lg:gap-x-12">
          <div className="flex-1 text-center font-secondary lg:text-left">
            <motion.h1
              variants={fadeIn("up", 0.3)}
              initial="hidden"
              whileInView={"show"}
              viewport={{ once: false, amount: 0.7 }}
              className="text-[40px] font-bold leading-[0.8] lg:text-[110px]"
            >
              ALFIN <span>VARGHESE</span>
            </motion.h1>
            <motion.h1
              variants={fadeIn("up", 0.5)}
              initial="hidden"
              whileInView={"show"}
              viewport={{ once: false, amount: 0.7 }}
              className="mb-6 text-[36px] lg:text-[60px] font-secondary font-semibold uppercase leading-[1]"
            >
              <span className="text-white mr-4"> I'm </span>
              <TypeAnimation
                sequence={[
                  "Developer",
                  2000,
                  "Designer",
                  2000,
                  "Photographer",
                  2000,
                ]}
                speed={50}
                className="text-accent"
                wrapper="span"
                repeat={Infinity}
              />
            </motion.h1>
            <motion.h1
              variants={fadeIn("up", 0.7)}
              initial="hidden"
              whileInView={"show"}
              viewport={{ once: false, amount: 0.7 }} className="mb-8 max-w-lg:mx-0">
              I’m Alfin Varghese, a passionate software developer.   
            </motion.h1>
            <motion.h1
              variants={fadeIn("up", 0.7)}
              initial="hidden"
              whileInView={"show"}
              viewport={{ once: false, amount: 0.7 }} className="flex max-w-max gap-x-6 items-center mb-12 mx-auto lg:mx-0">
              <button className="btn btn-lg">Contact me
              <a
                href="mailto:alfinvarghese07@gmail.com"
                
              /> </button>
              <a href=" services" className="text-gradient btn-link">
                {" "}
                {/* My Portfolio */}
              </a>
            </motion.h1>
            <motion.h1
              variants={fadeIn("up", 0.7)}
              initial="hidden"
              whileInView={"show"}
              viewport={{ once: false, amount: 0.7 }} className="flex text-[20px] gap-x-6 max-w-max mx-auto lg:mx-0">
              <a href="https://github.com/alfinvargheseonline">
                <FaGithub />
              </a>

              <a href="#">
                <FaDribbble />
              </a>

              <a href="https://www.linkedin.com/in/alfin-varghese2000/">
                <FaLinkedin />
              </a>
            </motion.h1>
          </div>
          <motion.h1
              variants={fadeIn("down", 0.7)}
              initial="hidden"
              whileInView={"show"}
              // viewport={{ once: false, amount: 0.7 }} 
              className="hiddden lg:flex flex-1 max-w-[420px] lf:max-w-[582px]">
            <img src={Image} alt="" />
          </motion.h1>
        </div>
      </div>
    </section>
  );
};

export default Banner;
